import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBank = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M2.75 8.75h14.5m-15.5 9.5h16.5M4 11.75v3.5m4-3.5v3.5m4-3.5v3.5m4-3.5v3.5m-14.25-9L10 1.75l8.25 4.5H1.75Z"
	})]
});
const ForwardRef = forwardRef(SvgBank);
export { ForwardRef as ReactComponent };
